import React from "react";
import ReactDOM from "react-dom/client";

import BuildContext from "@ui/context/BuildContext";
import TranslationContext from "@ui/context/TranslationContext";
import { ErrorWrapper } from "components/Error";
import ToastContainer from "components/ToastContainer";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import "./lib/sentry/sentryInit";

import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BuildContext>
      <TranslationContext>
        <ErrorWrapper fullPage withImage>
          <App />
          <ToastContainer />
        </ErrorWrapper>
      </TranslationContext>
    </BuildContext>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
